// AUTO-GENERATED - Do not manually edit this file
// This file is generated by scripts/devlink/config-generator/generate-props-config.js
export default {
    cta: "Learn more about monday's AI offering",
    sectionVisibility: true,
    title: "Your teams’ impact. Multiplied by AI."
};
